import React from "react";

const CheckmarkSharp = ({ color, height, width }) => (
  <svg
    class=""
    height={height}
    width={width}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-miterlimit="10"
      stroke-width="44"
      d="M416 128L192 384l-96-96"
    ></path>
  </svg>
);

export default CheckmarkSharp;
